import {useWauth} from "./WauthProvider";

// Sin sesión manda al login. Envuelve todas las rutas privadas a la vez: como en react-router 5, cualquier ruta privada
// (aunque no exista) redirige al login.
function RequireAuth({children}) {

  const {isAuthenticated, loginWithRedirect} = useWauth()

  if (!isAuthenticated) {
    loginWithRedirect()
    return null
  }

  return children
}

export default RequireAuth;
